import React from 'react';
import BarChartVertical from './BarChartVertical';
import BarChartHorizontal from './BarChartHorizontal';
import { COLOR_BAR_CHART } from 'consts/configCustom';

const InRowChart = ({ dashboard }) => {
  const fluidFlow = dashboard.find((item) => item[1] === 'Fluid Flow') || [
    null,
    null,
    0,
  ];

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: 'fit-content',
        gap: '10px',
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'row', gap: '2px' }}>
        {dashboard.map((item, index) => {
          if (!index) return null;
          if (item[1] === 'Fluid Flow') return null;
          return (
            <BarChartVertical
              key={index}
              label={item[1]}
              unit={'℃'}
              value={item[2]}
              percentage={(item[2] / 50) * 100}
              color={COLOR_BAR_CHART[index - 1]}
            />
          );
        })}
      </div>
      <BarChartHorizontal
        label="Fluid Flow"
        unit="m3/s"
        value={fluidFlow[2]}
        percentage={(fluidFlow[2] / 1) * 100}
      />
    </div>
  );
};

export default InRowChart;
